import React, {
    FC,
    useCallback,
    useLayoutEffect,
    useMemo,
    useState,
} from "react";
import { ChildrenProps } from "../../types";
import { newVersionAvailableContext } from "./NewVersionAvailableContext";
import { newVersionAvailableProxy } from "./NewVersionAvailable.lib";

export const NewVersionAvailableProvider: FC<ChildrenProps> = ({
    children,
}) => {
    const [isNoticeVisible, setIsNoticeVisible] = useState(false);

    const refresh = useCallback(() => {
        window.location.reload();
    }, []);

    const notifyNewVersionAvailable = useCallback(() => {
        setIsNoticeVisible(true);
    }, []);

    useLayoutEffect(() => {
        newVersionAvailableProxy.notifyNewVersionAvailable =
            notifyNewVersionAvailable;
    }, [notifyNewVersionAvailable]);

    const value = useMemo(
        () => ({
            notifyNewVersionAvailable,
            isNoticeVisible,
            refresh,
        }),
        [notifyNewVersionAvailable, isNoticeVisible, refresh],
    );

    return (
        <newVersionAvailableContext.Provider value={value}>
            {children}
        </newVersionAvailableContext.Provider>
    );
};
